<div class="datepicker">
  <div class="date-value flex-row flex-1 justify-between items-center">
    <span>{{ displayValue$ | async }}</span>
    <div class="mat-select-arrow-wrapper">
      <div class="mat-select-arrow"></div>
    </div>
  </div>

  <mat-form-field
    class="example-form-field"
    appearance="outline"
    [matTooltip]="'date_range_selector.tooltip' | translate"
    matTooltipShowDelay="1000"
    [matMenuTriggerFor]="menu"
  >
    <mat-select>
      <mat-date-range-input
        [formGroup]="dateGroup"
        [rangePicker]="dateRangePicker"
        [comparisonStart]="dateGroup.value.start"
        [comparisonEnd]="dateGroup.value.end"
        [max]="maxDate"
      >
        <input [style.display]="'none'" matStartDate formControlName="start" />
        <input [style.display]="'none'" matEndDate formControlName="end" />
      </mat-date-range-input>
      <mat-date-range-picker #dateRangePicker> </mat-date-range-picker>
    </mat-select>
  </mat-form-field>
</div>

<mat-menu #menu="matMenu">
  <div class="flex-row flex-1 justify-between items-center buttons">
    <button mat-flat-button (click)="slideRange('left'); $event.stopPropagation()">
      <mat-icon>chevron_left</mat-icon>
    </button>
    <button mat-flat-button (click)="slideRange('right'); $event.stopPropagation()">
      <mat-icon>chevron_right</mat-icon>
    </button>
  </div>
  <hr />

  <button mat-menu-item (click)="dateRangePicker.open()">
    {{ 'date_range_selector.own_selection' | translate }}
    <mat-icon slot="end">calendar_month</mat-icon>
  </button>
  <app-date-range-selector-predefined-ranges
    [maxDate]="maxDate"
    (rangeSelected)="selectPredefinedRange($any($event))"
  ></app-date-range-selector-predefined-ranges>
</mat-menu>
